import { lazy } from 'react';
import { PageRouter } from '@tools/ui/types';

const Manual = lazy(
  () => import(/* webpackChunkName: "VendorRoutes" */ '../pages/vendors/manual')
);

const VendorBalanceSharedNestedView = lazy(
  () =>
    import(
      /* webpackChunkName: "VendorRoutes" */ '../pages/vendors/VendorBalanceSharedNestedView'
    )
);

const Review = lazy(
  () => import(/* webpackChunkName: "VendorRoutes" */ '../pages/vendors/review')
);

const Alerted = lazy(
  () =>
    import(/* webpackChunkName: "VendorRoutes" */ '../pages/vendors/alerted')
);

export const vendorRoutes: PageRouter[] = [
  {
    name: 'vendors',
    path: '/vendors',
    component: VendorBalanceSharedNestedView,
    exact: false,
    tabs: [
      {
        name: 'review',
        path: '/review',
        component: Review
      },
      { name: 'alerted', path: '/alerted', component: Alerted },
      { name: 'manual', path: '/manual', component: Manual }
    ]
  }
];
